import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { SalesChartComponent } from "../charts";
import { Carousel, Modal, Button, Form, Alert } from "react-bootstrap";

import "../../../src/assets/sass/custom.css";
export default function DashBoardImageSlider({ images }) {
  const { t } = useContext(TranslatorContext);
  return (
    <div className="mc-sales-card" style={{ height: "300px" }}>
      <Carousel fade>
        {

          images.map((imgSrc, index) => {
            return (
              <Carousel.Item key={index}>

                <img
                  style={{ borderRadius: "10px", objectFit: "cover" }}
                  src={process.env.REACT_APP_IMG_URL + imgSrc.release_img}
                  width="100%"
                  height="300px"
                ></img>
              </Carousel.Item>
            )
          })
        }


      </Carousel>


    </div>
  );
}
